import { useSessionUser } from "hooks/useSession";
import { useNavigate } from "react-router-dom";
import { ENVS, PATH_DASHBOARD } from "config";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../modal";
import { Button } from "../buttons/Button";
import { HiOutlineArrowSmRight } from "react-icons/hi";

interface ProjectQuotaModalProps {
  name: string;
  open: boolean;
  setOpen: () => void;
}

export const ProjectQuotaModal: React.FC<ProjectQuotaModalProps> = ({
  name: _name,
  open,
  setOpen,
}) => {
  const navigate = useNavigate();
  const { session: profile } = useSessionUser();
  const isFreePlan = profile?.pricing_plan_id === Number(ENVS.freePlanId);

  return (
    <Modal isOpen={open} onClose={setOpen}>
      <ModalHeader title="Project Quota Reached" onClose={setOpen} />
      <ModalBody>
        {`You've reached your ${isFreePlan ? "" : "monthly"} project quota.`} <br />
        To continue, please upgrade your plan.
      </ModalBody>
      <ModalFooter className="justify-end">
        <Button size="lg" variant="ghostSecondary" onClick={setOpen}>
          Close
        </Button>
        <Button
          onClick={() => {
            isFreePlan ? navigate(PATH_DASHBOARD.selectPlan) : navigate(PATH_DASHBOARD.upgrade);
          }}
        >
          Upgrade Plan <HiOutlineArrowSmRight />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProjectQuotaModal;
